import { useIntl } from "react-intl";

export const useTranslationFooter = () => {
  const intl = useIntl();

  const generalTranslation = intl.formatMessage({
    defaultMessage: "General",
    id: "footer.tab.title.general",
  });

  const pricingTranslation = intl.formatMessage({
    defaultMessage: "Pricing",
    id: "footer.tab.pricing",
  });

  const termsAndConditionsTranslation = intl.formatMessage({
    defaultMessage: "Terms and conditions",
    id: "footer.tab.termsAndConditions",
  });
  const documentationTranslation = intl.formatMessage({
    defaultMessage: "Documentation",
    id: "footer.tab.documentation",
  });
  const contactUsTranslation = intl.formatMessage({
    defaultMessage: "Book a call",
    id: "generic.contactUs.calendly",
  });

  return {
    generalTranslation,
    pricingTranslation,
    termsAndConditionsTranslation,
    documentationTranslation,
    contactUsTranslation,
  };
};
